<template lang="pug">

    div

        table.ui.striped.fixed.mini.form.table(v-for='printing in printings')

            thead
                tr
                    th.ui.medium.header(colspan=13) Auflage: {{ printing }}
                tr
                    th Lieferant
                    th HK
                    th DB HK
                    th VK Produktion
                    th Versand
                    th DB Versand
                    th VK Versand
                    th Zusatzkosten
                    th Verkaufspreis
                    th DB Gesamt
                    th Tausenderpreis
                    th Angebotsgültigkeit Lieferant
                    th Angebotsgültigkeit DuW

            tbody
                tr(
                    ref="rows"
                    is='price-table-form-row'
                    v-for="priceModel in getPriceModelsByPrinting(printing)"
                    v-bind:key='priceModel.id'
                    v-bind:additional-cost-models='getAdditionalCostModelsByPriceId(priceModel.id)'
                    v-bind:offer-model='getOfferModelById(priceModel.offer)'
                    v-bind:price-model='priceModel'
                    v-bind:supplier-model='getSupplierModelByOfferId(priceModel.offer)'
                    v-on:input-offer='updateOfferModel'
                    v-on:input='updatePriceModel'
                )

</template>

<script>
    import * as R from 'ramda'
    import PriceTableFormRow from './PriceTableFormRow'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { PriceTableFormRow },

        data() {
            return {
                valueModels: R.clone(this.priceModels)
            }
        },

        methods: {

            getAdditionalCostModelsByPriceId(priceId) {
                return R.filter(R.propEq('price', priceId), this.additionalCostModels)
            },

            getOfferModelById(id) {
                return R.find(R.propEq('id', id), this.offerModels)
            },

            getPriceModelsByPrinting(printing) {
                return R.filter(R.propEq('printing', printing), this.valueModels)
            },

            getSupplierModelByOfferId(offerId) {
                return R.compose(

                    // Lieferant anhand des Jobs holen
                    jobModel => R.find(R.propEq('id', jobModel.supplier), this.supplierModels),

                    // Job-Model anhand des Angebots holen
                    offerModel => R.find(R.propEq('id', offerModel.job), this.jobModels),

                    // Angebote holen
                    this.getOfferModelById

                )(offerId)
            },

            async persist() {
                return R.compose(

                    // Promises zusammenfassen
                    // > [ Promise, Promise ]
                    // < Promise
                    promises => Promise.all(promises),

                    // Validierung fuer Zeilen ausloesen
                    // > [ VueComponent, VueComponent ]
                    // < [ Promise, Promise ]
                    R.map(row => row.persist()),

                )(this.$refs.rows)
            },

            updatePriceModel(priceModel) {
                R.compose(

                    // `input`-Event ausloesen
                    models => this.$emit('input', models),

                    // Aktualisierten Preis setzen
                    R.update(R.findIndex(R.propEq('id', priceModel.id), this.valueModels), priceModel)

                )(this.valueModels)
            },

            updateOfferModel(offerModel) {
                R.compose(

                    // `input`-Event ausloesen
                    offerModels => this.$emit('input-offers', offerModels),

                    // Aktualisiertes Angebot setzen
                    R.update(R.findIndex(R.propEq('id', offerModel.id), this.offerModels), offerModel)

                )(this.offerModels)
            },

            async validate() {
                const validations = R.compose(

                    // Promises zusammenfassen
                    // > [ Promise, Promise ]
                    // < Promise
                    promises => Promise.all(promises),

                    // Validierung fuer Zeilen ausloesen
                    // > [ VueComponent, VueComponent ]
                    // < [ Promise, Promise ]
                    R.map(row => row.validate()),

                )(this.$refs.rows)

                // Alle Validierungen pruefen
                return R.all(R.equals(true), await validations)
            }

        },

        props: {

            additionalCostModels: {
                type: Array,
                required: true,
            },

            jobModels: {
                type: Array,
                required: true
            },

            offerModels: {
                type: Array,
                required: true
            },

            priceModels: {
                type: Array,
                required: true
            },

            printings: {
                type: Array,
                required: true
            },

            supplierModels: {
                type: Array,
                required: true
            }

        },

        watch: {

            priceModels(models) {
                this.valueModels = R.clone(models)
            }

        }

    }

</script>
